import { Effect } from "../Materials/effect";
var name = 'gpuUpdateParticlesPixelShader';
var shader = "#version 300 es\nvoid main() {\ndiscard;\n}\n";
Effect.ShadersStore[name] = shader;
/** @hidden */
export var gpuUpdateParticlesPixelShader = { name: name, shader: shader };
